import { FormikErrors, useFormikContext } from "formik";
import React, { useEffect } from "react";

const getErrorPaths = <T>(
  errors: FormikErrors<T> | FormikErrors<T>[keyof FormikErrors<T>],
  path: string[] = []
): string[][] => {
  if (!errors) {
    return [];
  }
  if (typeof errors === "string" || Array.isArray(errors)) {
    return [path];
  }

  return Object.keys(errors!).flatMap(key =>
    // @ts-ignore
    getErrorPaths(errors[key], [...path, key])
  );
};
export const useScrollToFirstErrorOnSubmit = <T>(
  ref: React.MutableRefObject<HTMLDivElement | null>
) => {
  const { errors, isValid, isSubmitting } = useFormikContext<T>();
  useEffect(() => {
    if (!isValid && isSubmitting && ref.current) {
      const flattenedErrorSelector = getErrorPaths(errors)
        .map(path => `[name="${path.join(".")}"]`)
        .join(", ");
      // Select the first descendant of the ref that has the same field name as
      // any of the errors.
      const firstErrorField = ref.current.querySelector(flattenedErrorSelector);
      if (firstErrorField) {
        firstErrorField.scrollIntoView();
      }
    }
  }, [isValid, isSubmitting, errors, ref]);
};
